import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import NavigationBarButtonImpl from './navigation-bar-button';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Button shown at the bottom of an event list to navigate to all events, a type page, or a coupon page.
 *
 * @class NavigationBarButton
 * @memberof Mojito.Modules.EventList
 */

/**
 * NavigationBarButton prop types.
 *
 * @property {string} eventGroupsId - Event groups subscription id.
 * @property {string} sportId - Sport id.
 * @property {string} sportName - Sport display name.
 * @property {boolean} [redirectToTypePage] - When true, coupon navigation goes to the sport type page; otherwise to the coupon page.
 * @property {string} [label] - Button label. When omitted, defaults to the all-events label for the sport.
 * @property {number} renderedEventCount - Number of events currently rendered.
 * @property {string} [typeId] - Sport type id used for type-page redirects.
 * @property {boolean} [isCouponNavigation = false] - When true, navigation goes to the coupon or type page.
 * @property {boolean} [showAllEventsButton = false] - Whether the navigation button is shown. Visibility rules are resolved by the parent.
 * @property {boolean} [allowTypePageRedirect = true] - When false, truncated coupons redirect to the coupon page instead of the type page.
 * @property {boolean} [isInPlay = false] - Whether the list is for live events.
 * @property {Function} [onShowAllButtonClick] - Callback triggered for sport/in-play navigation.
 *
 * @memberof Mojito.Modules.EventList.NavigationBarButton
 */
const propTypes = {
    eventGroupsId: PropTypes.string,
    sportId: PropTypes.string,
    sportName: PropTypes.string,
    redirectToTypePage: PropTypes.bool,
    label: PropTypes.string,
    renderedEventCount: PropTypes.number,
    typeId: PropTypes.string,
    showAllEventsButton: PropTypes.bool,
    isCouponNavigation: PropTypes.bool,
    allowTypePageRedirect: PropTypes.bool,
    isInPlay: PropTypes.bool,
    onShowAllButtonClick: PropTypes.func,
};

const defaultProps = {
    showAllEventsButton: false,
    isCouponNavigation: false,
    allowTypePageRedirect: true,
    isInPlay: false,
    onShowAllButtonClick: noop,
};

export default UIView('NavigationBarButton', NavigationBarButtonImpl, propTypes, defaultProps);
